/**
 * Sentry configuration for admin_portal
 *
 * Uses shared Sentry utilities from @ekhodealer/ekho-common.
 * For basic Sentry operations (setUser, setTag, captureException, etc.),
 * import directly from '@sentry/react'.
 */
import { EKHO_APPS_ENUM } from '@ekhodealer/ekho-common';
import { initializeSentry as initializeSentryBase } from '@ekhodealer/ekho-common/utils/sentry';

import type { Environment} from '@ekhodealer/ekho-common';

const SENTRY_DSN =
	'https://a81df6617ee4d23a0ac5158afb99d20d@o4510596785766400.ingest.us.sentry.io/4510615596564480';

/**
 * Initialize Sentry for admin_portal
 */
export function initializeSentry(): void {
	initializeSentryBase({
		dsn: SENTRY_DSN,
		appName: EKHO_APPS_ENUM.ADMIN_PORTAL,
		environment: import.meta.env.VITE_CURR_ENV as Environment,
		reactRouterVersion: 'v7',
	});
}
